import Store from 'store/store';

// Used for server-side rendering
const PLACEHOLDER_DOMAIN = 'https://placeholder/';

// Query params to preserve across navigation
const PRESERVED_PARAMS = ['cms-preview'];

const movieSpecificPages = {
	movie: '/',
	showtimes: '/tickets/',
	homeEnt: '/watch-at-home/',
};

export function getLink(page, details) {
	const [pageName, anchor] = page.split('#');
	const pageData = Store.get().appData.pages[pageName];
	let path = pageData?.path;
	const movieSubPath = movieSpecificPages[pageName];
	if (movieSubPath) {
		const externalLink = details?.movie?.link || details?.movie?.url;
		if (externalLink) return { href: externalLink, external: true };
		let slug = details?.slug || details?.movie?.slug;
		if (slug) {
			path = `${__IS_LOCAL__ || __IS_DEMO__ ? '/#' : ''}/films/${slug}${movieSubPath}`;
		}
	}

	if (!path) return null;

	let base = (typeof window !== 'undefined' && window.__BASE_URL__) || PLACEHOLDER_DOMAIN;

	let url = new URL('.' + path, base);

	// Preserve specific query params from the current URL
	if (typeof window !== 'undefined') {
		const currentParams = new URLSearchParams(window.location.search);
		PRESERVED_PARAMS.forEach(param => {
			const value = currentParams.get(param);
			if (value !== null) url.searchParams.set(param, value);
		});
	}

	if (details?.query) {
		Object.entries(details.query).forEach((entry) => url.searchParams.set(...entry));
	}
	if (anchor) url.hash = anchor;

	let href = url.href.replace(PLACEHOLDER_DOMAIN, '/').replace(/=(&|$)/g, '$1');
	return { href };
}

export function navigate(page, details) {
	const link = getLink(page, details);
	if (!link) return;
	if (link.external) {
		location.href = link.href;
	} else {
		const fn = details?.replace ? 'replaceState' : 'pushState';
		history[fn]({}, '', link.href);
		window.dispatchEvent(new CustomEvent('popstate'));
	}
}